import React from 'react';
import {AttentionNotice} from 'sail/Notice';
import Box from 'sail/Box';
import {InlineLink} from 'sail/InlineLink';
import {Body} from 'sail/Text';
import '../css/NarrowScreenWarning.scss';
import {defineMessages, FormattedMessage} from 'react-intl';
import {useContent} from '../data/ContentProvider';

const messages = defineMessages({
  title: {
    id: 'docsApp.integrationBuilder.narrowScreenWarning.title',
    description: 'Title for narrow screen warning',
    defaultMessage: 'This page is optimized for wider screens.',
  },
  body: {
    id: 'docsApp.integrationBuilder.narrowScreenWarning.body',
    description: 'Body for narrow screen warning',
    defaultMessage:
      'You might prefer the <link>text version of this guide</link>.',
  },
});

const NarrowScreenWarning = (props) => {
  const {integrationType} = useContent();
  let href = '';

  switch (integrationType) {
    case 'terminal':
      href = '/docs/terminal/payments/setup-sdk';
      break;
    default:
      href = '/docs/payments/accept-a-payment';
  }

  return (
    <Box className="NarrowScreenWarning">
      <AttentionNotice
        title={<FormattedMessage {...messages.title} />}
        description={
          <Body>
            <FormattedMessage
              {...messages.body}
              values={{
                link: (str) => <InlineLink href={href}>{str}</InlineLink>,
              }}
            />
          </Body>
        }
      />
    </Box>
  );
};

export default NarrowScreenWarning;
